import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import ResultInt from '../../_interface/result-int';
import NebulaModuleBase from './module-base';
export var UpSystem = function (_NebulaModuleBase) {
    _inherits(UpSystem, _NebulaModuleBase);

    function UpSystem() {
        _classCallCheck(this, UpSystem);

        var _this = _possibleConstructorReturn(this, (UpSystem.__proto__ || Object.getPrototypeOf(UpSystem)).apply(this, arguments));

        _this.heightOfKeyboardListeners = new Map();
        // 输入法高度状态监听事件分发
        _this.onContainerKeyboardEvent = function (event) {
            var _a, _b, _c, _d, _e, _f;
            // 解析高度获取数据
            var eventName = (_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.messageName) !== null && _b !== void 0 ? _b : '';
            var height = (_e = (_d = (_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.messageData) === null || _d === void 0 ? void 0 : _d.keyboardHeight) !== null && _e !== void 0 ? _e : '';
            if (eventName === 'KeyboardDidShow') {
                (_f = _this.heightOfKeyboardListeners) === null || _f === void 0 ? void 0 : _f.forEach(function (listener) {
                    try {
                        var isIOS = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                        var data = {
                            height: isIOS ? '' : height
                        };
                        listener(data);
                    } catch (error) {
                        window.console.info('onContainerKeyboardEvent ' + event.type + ' error', error);
                    }
                });
            }
        };
        return _this;
    }

    _createClass(UpSystem, [{
        key: 'setClipboard',
        value: function setClipboard(param) {
            return this.generatePromiseByFunctionWithParams('setClipboardForAction', param);
        }
    }, {
        key: 'getClipboard',
        value: function getClipboard() {
            return this.generatePromiseByFunctionWithParams('getClipboardForAction', null);
        }
    }, {
        key: 'setScreenSecure',
        value: function setScreenSecure(param) {
            return this.generatePromiseByFunctionWithParams('setScreenSecureForAction', param);
        }
    }, {
        key: 'setNebulaTitleBar',
        value: function setNebulaTitleBar(param) {
            return this.generatePromiseByFunctionWithParams('setNebulaTitleBar', param);
        }
    }, {
        key: 'createDesktopShortcut',
        value: function createDesktopShortcut(param) {
            return this.generatePromiseByFunctionWithParams('createDesktopShortcutForAction', param);
        }
    }, {
        key: 'preventAutomaticLockScreen',
        value: function preventAutomaticLockScreen(param) {
            return this.generatePromiseByFunctionWithParams('preventLockScreenForAction', param);
        }
    }, {
        key: 'checkAppInstallForSystem',
        value: function checkAppInstallForSystem(param) {
            return this.generatePromiseByFunctionWithParams('checkAppInstallForSystem', param);
        }
    }, {
        key: 'addHeightOfKeyboardListener',
        value: function addHeightOfKeyboardListener(params) {
            var event = 'KeyboardEvent';
            var paramsObj = {
                eventName: event,
                key: params.keyName
            };
            if (!this.heightOfKeyboardListeners || this.heightOfKeyboardListeners.size === 0) {
                document.addEventListener(event, this.onContainerKeyboardEvent, false);
            }
            this.heightOfKeyboardListeners.set(params.keyName, params.eventListener);
            return this.generatePromiseByFunctionWithParams('addKeyboardSubscriptionForAction', paramsObj);
        }
    }, {
        key: 'removeHeightOfKeyboardListener',
        value: function removeHeightOfKeyboardListener(params) {
            var event = 'KeyboardEvent';
            var paramsObj = {
                eventName: event,
                key: params.keyName
            };
            var deleteResult = this.heightOfKeyboardListeners['delete'](params.keyName);
            window.console.info('Detach ' + event + ' ,result=' + deleteResult + ', size= ' + this.heightOfKeyboardListeners.size);
            if (!deleteResult) {
                return Promise.reject(new ResultInt('000001', '\u76D1\u542C\u56DE\u8C03\u4E0D\u5B58\u5728'));
            } else {
                if (!this.heightOfKeyboardListeners || this.heightOfKeyboardListeners.size === 0) {
                    document.removeEventListener(event, this.onContainerKeyboardEvent, false);
                }
                return this.generatePromiseByFunctionWithParams('detchBluetoothStatusListenerAction', paramsObj);
            }
        }
    }]);

    return UpSystem;
}(NebulaModuleBase);